export const formatInt = (n) => parseInt(n).toLocaleString();

export const formatDp = (num, dps) => {
  if (num === null) return null;
  const fl = parseFloat(num) || 0;
  return fl.toLocaleString(undefined, { maximumFractionDigits: dps, minimumFractionDigits: dps });
};

export const formatMaxDp = (num, dps) => {
  const fl = parseFloat(num) || 0;
  return fl.toLocaleString(undefined, { maximumFractionDigits: dps });
};

export const formatDpPct = (num, dps) => (formatDp(num, dps) ? formatDp(num, dps) + "%" : "N/A");

export const formatThousands = (num) => num.toLocaleString(undefined, {});

export const countDecimals = (n = 0) => {
  if (Math.floor(n.valueOf()) === n.valueOf()) return 0;
  return n.toString().split(".")[1]?.length || 0;
};
